<script lang="ts">
  import Button from '../ui/Button.svelte';
  import InlineMessage from '../ui/InlineMessage.svelte';

  /** A room without an authoritative snapshot yet: a spinner while work is under way, else a retry. */
  interface Props {
    busy: boolean;
    error: string;
    retry: () => void;
  }
  let { busy, error, retry }: Props = $props();
</script>

<section id="screen-loading" class="screen loading-screen" aria-busy={busy}>
  {#if busy}
    <div role="status" aria-label="Loading">
      <div class="loading-spinner" aria-hidden="true"></div>
    </div>
  {:else}
    <InlineMessage intent="error">{error || 'Could not load. Try again.'}</InlineMessage>
    <Button onclick={retry}>Try Again</Button>
  {/if}
</section>

<style>
  .loading-screen {
    justify-content: center;
    gap: 16px;
    padding: 24px 0;
  }
  .loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--theme-spinner-track);
    border-top-color: var(--theme-spinner-color);
    border-radius: var(--theme-spinner-radius);
    animation: var(--theme-spinner-animation);
  }
</style>
